<template>
  <transition name="bounce">
    <b-container class="py-5 custom-container container">
      <b-breadcrumb
        :items="items"
        class="pl-0 pt-5 mt-5 bg-transparent"
      ></b-breadcrumb>
      <h2 class="font-weight-bold">New file</h2>
      <b-card class="mt-4">
        <div class="mx-auto p-lg-5 w-75">
          <h4 class="font-weight-bold mb-4">
            {{ screenTitle }}
          </h4>
          <new-file-form
            :is-request-file-creation="isRequestFileCreation"
            :file-request-user-id="fileRequestUserId"
            :request="request ? request.file_request : null"
          />
        </div>
      </b-card>
    </b-container>
  </transition>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import NewFileForm from '@/components/forms/NewFileForm'

export default {
  components: {
    NewFileForm
  },
  data() {
    return {
      screenTitle:
        'Select the type of information you would like to manually add.'
    }
  },
  computed: {
    ...mapState({
      currentScreen: state => state.file.currentScreen
    }),
    ...mapGetters('requests', ['request']),
    items() {
      return [
        {
          text: 'File Upload',
          to: this.isRequestFileCreation
            ? `/request/file/${this.fileRequestUserId}/templates`
            : '/templates'
        },
        { text: 'New File' }
      ]
    },

    isRequestFileCreation() {
      return this.$route.name === 'request.request-file-new-page'
    },

    fileRequestUserId() {
      if (this.isRequestFileCreation) {
        return this.$route.params.fileRequestUserId
      } else {
        return null
      }
    }
  },

  methods: {
    ...mapActions({
      getRequestByUser: 'requests/getRequestByUser'
    })
  },

  watch: {
    currentScreen(value) {
      if (value === 'Upload') {
        this.screenTitle = 'Upload your file'
      }
    }
  },

  async mounted() {
    if (this.isRequestFileCreation) {
      await this.getRequestByUser(this.fileRequestUserId).catch(err => {
        if (err.data.status === 404) {
          this.$router.replace({ name: 'page-not-found' })
        }
      })
    }
  }
}
</script>
